import { gql } from '@reverbdotcom/commons/src/gql';
import {
  Core_Crupdate_GearCollectionItemMutation,
  Core_Delete_GearCollectionItemMutation,
} from '@reverbdotcom/commons/src/gql/graphql';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';

export const GearCollectionCSPDataFragment = gql(`
  fragment GearCollectionCSPData on CSP {
    _id
    id
    title
    brand {
      _id
      name
    }
    webLink {
      href
      path
    }
    image(input: { transform: "card_square" }) {
      _id
      source
    }
  }
`);

export const UPDATE_GEAR_COLLECTION_ITEM_MUTATION = gql(`
  mutation Core_Crupdate_GearCollectionItem(
    $input: Input_core_apimessages_UpdateGearCollectionItemRequest
  ) {
    crupdateGearCollectionItem(input: $input) {
      _id
      ...GearCollectionItemShowDisplayData
    }
  }
`);

export function useUpdateGearCollectionItemMutation() {
  return useMutation<Core_Crupdate_GearCollectionItemMutation>(UPDATE_GEAR_COLLECTION_ITEM_MUTATION);
}

export const DELETE_GEAR_COLLECTION_ITEM_MUTATION = gql(`
  mutation Core_Delete_GearCollectionItem($input: Input_core_apimessages_DeleteGearCollectionItemRequest) {
    deleteGearCollectionItem(input: $input) {
      _id
      ...GearCollectionItemShowDisplayData
    }
  }
`);

export function useDeleteGearCollectionItemMutation() {
  return useMutation<Core_Delete_GearCollectionItemMutation>(DELETE_GEAR_COLLECTION_ITEM_MUTATION);
}

export const SEED_GEAR_COLLECTION_ITEM_QUERY = gql(`
  query Core_GearCollectionItem_Form(
    $shouldSeedListingData: Boolean!
    $shouldFetchCsp: Boolean!
    $seedId: String
    $seedType: core_apimessages_Listing_SeedType
    $cspId: String
  ) {
    seedListing(input: { seedId: $seedId, seedType: $seedType }) @include(if: $shouldSeedListingData) {
      listing {
        make
        model
        brandSlug
        categoryRootUuid
        subcategoryLeafUuids
        canonicalProductId
        finish
        year
        conditionSlug
        sellerCost {
          amount
          amountCents
          currency
          display
        }
      }
    }
    csp(input: { id: $cspId }) @include(if: $shouldFetchCsp) {
      _id
      ...GearCollectionCSPData
    }
  }
`);
